module.exports = __webpack_public_path__ + "img/upper pocket width.65b0975d.png";